<!--设备数据-->
<template>
  <div>
    <!-- <img src="../../../../equipmentimg/topborder.png" class="topborder-box">
    <img src="../../../../equipmentimg/bottomborder.png" class="bottomborder-box"> -->
    <div class="data-text"  style="top: 85px;">电量水量</div>
    <div class="hidden"></div>
    <div class="hidden1"></div>
    <div class="all-left-top-box" style="width: 104%;margin-top: -105px;">
      <div class = "e-title-box">
        当前数据时间: {{this.deviceData.proDataTime}}
      </div>

      <div style="background-color:#0A2D57;width:94%;padding-top:20px;height:auto">

        <div class="border-x">
          <img src="../../../../equipmentimg/topborder.png" class="topborder-box">

          <a-row  :gutter="[10,8]" style="margin-left:15px;margin-top:20px;width:100%;">

            <a-col :span="6" v-for="item in eightpropertiesR" :key="item.ID" style="margin:3px -2px" >
              <div class="e-card-single-box i">
                <img :src="item.cIcon" alt="" class="e-img-wh">
                <div class="e-card-text-box">
                  <div style="width: 150px;    overflow: hidden;">{{item.name}}</div>
                  <div class="e-card-text-blue"><span class="e-card-text-big">{{item.dataValue}}</span><span class="e-card-text-unit">{{item.dataUnit}}</span></div>
                </div>
              </div>

            </a-col>

            <a-col :offset="23" :span="1"><a-button   class="morebox" @click="more" type="link"></a-button></a-col>
          </a-row>
        </div>
        <img src="../../../../equipmentimg/bottomborder.png" class="bottomborder-box">
      </div>
    </div>

    <a-card class="all-card-style " style="'background:#001528">
      <!--筛选条件-->
      <div class="search-box">
        <a-form layout="inline" :form="form" @submit="">

          <a-form-item
            label="展现形式" class="ant-form-item2"
          >
            <a-button-group>
              <a-button @click="showLine" >曲线</a-button>
              <a-button @click="showTable">表格</a-button>
            </a-button-group>
          </a-form-item>

          <a-form-item
            label="起止日期" class="ant-form-item2"
          >
            <a-range-picker
              :default-value="[deviceData.queryInfoList.startDate, deviceData.queryInfoList.endDate]"
              @change="dateSelect"
            />
          </a-form-item>

          <a-form-item>
            <a-select :value="proSelectItem.value" class="ant-form-item2" style="width: 120px;color:#ffffff;background: #0a2d57;" @change="proSelect">
              <!-- <a-select-option value="1">
                全部
              </a-select-option>
              <a-select-option value="2">
                溶解氧
              </a-select-option>
              <a-select-option value="3">
                PH值
              </a-select-option>
              <a-select-option value="4">
                水温
              </a-select-option>
              <a-select-option value="5">
                压力
              </a-select-option> -->
              <a-select-option v-for="(item,index) in proSelectItems" :key="item.key" :value="index" style="background-color: #0A2D57 !important;">
                {{item.value}}
              </a-select-option>

            </a-select>
          </a-form-item>

          <a-form-item>
            <a-select default-value="实时曲线" class="ant-form-item2"  style="width: 120px" >
              <a-select-option value="1">
                实时曲线
              </a-select-option>
              <!-- <a-select-option value="2">
                历史曲线
              </a-select-option> -->
              <a-select-option value="3">
                早均线
              </a-select-option>
              <a-select-option value="4">
                晚均线
              </a-select-option>
              <a-select-option value="5">
                日均线
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="button" @click="search">
              查询
            </a-button>
            <span class="button-margin"></span>
            <a-button html-type="submit" >
              导出
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--曲线-->
      <div  v-show="lineVisible">
        <div id="c1"></div>
      </div>

      <!--    表格-->
      <div v-if="tableVisible">
        <a-table :columns="columns" :data-source="deviceData.dataList"></a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
import TitleCard from '@/components/TitleCard.vue'
import { Chart } from '@antv/g2'
import { _getDevicePropData } from '@/common/request.js'

const columns = [

  {
    title: '时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '原始值',
    dataIndex: 'value',
    key: 'value'
  }
]

const data = [
  {
    key: '1',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },
  {
    key: '2',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },
  {
    key: '3',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },

  {
    key: '4',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },

  {
    key: '5',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  }
]

const data2 = [
  { time: '1991', value: '3' },
  { time: '1992', value: '4' },
  { time: '1993', value: '3.5' },
  { time: '1994', value: '6' },
  { time: '1995', value: '4.9' },
  { time: '1996', value: '6' },
  { time: '1997', value: '7' },
  { time: '1998', value: '9' },
  { time: '1999', value: '13' }
]
export default {
  name: 'equipmentDataList',
  components: {

  },
  data () {
    return {
      form: this.$form.createForm(this),
      lineVisible: true,
      tableVisible: false,
      columns,
      data,
      data2,
      chart: {},
      IotId: '',
      proSelectItems: [],
      proSelectItem: {
        key: '',
        value: ''
      },
      timeTypeSel: [
        { ID: 1, name: '实时曲线' },
        { ID: 2, name: '早均线' },
        { ID: 3, name: '晚均线' },
        { ID: 4, name: '日均线' }
      ],
      deviceData: {
        queryInfo: {
          productkey: '',
          devicename: '',
          limit: 1
        },
        queryInfoList: {
          productkey: '',
          devicename: '',
          identifier: '',
          startDate: '1900-01-01',
          endDate: '1900-01-01',
          page: 0,
          limit: 0,
          timeType: 1
        },
        devices: {},
        proDataTime: '',
        propertiesR: [],
        dataList: [],
        timer: '', // 定时器
        timerList: ''
      },
      totalpropertiesR: [],
      eightpropertiesR: []
    }
  },
  created () {
    this.init1()
  },
  mounted () {
    this.createLine()
    // this.deviceData.timer = setInterval(this.getDevicePropData, 10000);//定时10秒

    // this.deviceData.timerList = setInterval(this.getDevicePropListData, 10000);//定时10秒
  },
  methods: {

    async init1 () {
      this.deviceData.queryInfoList.startDate = this.utils.getDate()
      this.deviceData.queryInfoList.endDate = this.utils.getDate('nextday')
      this.IotId = this.$route.query.IotId
      //  var device=this.$store.getters.Devices.filter(x=>x.IotId==this.IotId)[0]

      const res = await this.$http.post('WLWDevice/List', {
        sceneId: this.$store.getters.SCene.ID,
        cEntID: this.$store.getters.User.enterprise.ID,
        cSystemCode: '设施园艺'
      })
      let device = res.data.obj.list
      device = device.filter(x => x.IotId == this.IotId)[0]

      if (device != null) this.deviceData.devices = device
      const ThingModel = this.$store.getters.ThingModels.filter(x => x.productKey == this.deviceData.devices.ProductKey)[0]

      if (ThingModel != null) {
        const _pr = []
        for (let i = 0; i < ThingModel.propertiesR.length; i++) {
          if (ThingModel.propertiesR[i].identifier == 'TotalWater' ||
              ThingModel.propertiesR[i].identifier == 'TotalConsume'
          ) {
            _pr.push(ThingModel.propertiesR[i])
          }
        }

        this.deviceData.propertiesR = _pr
        this.deviceData.propertiesR.forEach(element => {
          let src = ''
          if (element.cIcon) {
            src = element.cIcon
          } else {
            src = '../../../../img/sandan.png'
          }
          element.cIcon = src
          const item = {
            cIcon: src,
            key: element.identifier,
            value: element.name
          }

          this.proSelectItems.push(item)
        })

        if (this.proSelectItems.length > 0) {
          this.proSelectItem = this.proSelectItems[0]
          this.deviceData.queryInfoList.identifier = this.proSelectItem.key
        }
      }
      this.deviceData.queryInfo.productkey = this.deviceData.devices.ProductKey
      this.deviceData.queryInfo.devicename = this.deviceData.devices.DeviceName
      this.deviceData.queryInfoList.productkey = this.deviceData.devices.ProductKey
      this.deviceData.queryInfoList.devicename = this.deviceData.devices.DeviceName
      this.getDevicePropData()
      this.getDevicePropListData()
    },

    showLine: function () {
      this.lineVisible = true
      this.tableVisible = false
      // this.reloadDrawing()
    },
    showTable: function () {
      // this.reloadDrawing();

      this.lineVisible = false
      this.tableVisible = true
    },
    createLine: function () {
      // Step 1: 创建 Chart 对象
      this.chart = new Chart({
        container: 'c1',
        autoFit: true,
        width: 800,
        height: 500,
        padding: [30, 100, 30, 40]
      })

      // Step 2: 载入数据源
      // this.chart.data(data2);
      this.chart.changeData(this.deviceData.dataList)
      // Step 3：创建图形语法，绘制柱状图
      // this.chart.interval().position('genre*sold');
      // var pro=this.deviceData.propertiesR.filter(x=>x.identifier==this.deviceData.queryInfoList.identifier)
      // if(pro!=null){
      //   min=this.utils.formatNumber(pro[0].dataSpecs.min)
      //   max=this.utils.formatNumber(pro[0].dataSpecs.max)
      //   step=this.utils.formatNumber(pro[0].dataSpecs.step)
      // }
      // min=0.0
      //   max=20.0
      //   step=0.01
      this.chart.scale({
        time: {
          range: [0.05, 0.95],
          type: 'time',
          mask: 'MM-DD hh:mm:ss',
          nice: true
        },
        value: {
          // min: min,
          // max:max,
          // tickInterval: step,
          nice: true
        }
      })
      this.chart.tooltip({
        showCrosshairs: true, // 展示 Tooltip 辅助线
        shared: true
      })
      // this.chart.line().position('year*value').label('value');
      // this.chart.point().position('year*value');
      this.chart.line().position('time*value')
      this.chart.point().size(2).position('time*value')
      // Step 4: 渲染图表
      this.chart.render()
    },
    reloadDrawing: function () {
      // 销毁画布对象
      this.chart.destroy()
      // 重新调用数据进行加载
      this.createLine()
    },
    async getDevicePropData () {
      const res = await _getDevicePropData(this, this.deviceData.queryInfo)

      if (res != null) {
        const data = res.obj.list
        if (data != null && data.length > 0) {
          this.deviceData.proDataTime = data[0].gmtCreateDes
          const dataItems = data[0].dataItems

          this.deviceData.propertiesR.forEach(element => {
            if (dataItems[element.identifier] != null) {
              const value = this.utils.formatPropData(element, dataItems[element.identifier].value)
              this.$set(element, 'dataValue', value)
            }
          })
          this.totalpropertiesR = this.deviceData.propertiesR

          if (this.deviceData.propertiesR && this.deviceData.propertiesR.length > 8) {
            this.eightpropertiesR = this.deviceData.propertiesR.slice(0, 8)
          } else {
            this.eightpropertiesR = this.deviceData.propertiesR
          }
        }
      } else {
        this.$message.error(res.message)
      }
    },
    async getDevicePropListData () {
      const hide = this.$message.loading('正在获取设备数据请稍候..', 0)
      const res = await this.$http.post('WLWDevice/DevicePropertyDataChartList', this.deviceData.queryInfoList)

      setTimeout(hide, 100)
      if (res != null) {
        const data = res.data.obj.list

        this.deviceData.dataList.splice(0)

        if (data != null && data.length > 0) {
          data.forEach(element => {
            const item = {
              time: element.time,
              value: this.utils.formatNumber(element.values, 1)
            }
            this.deviceData.dataList.push(item)
          })
        }

        this.chart.render()
      } else {
        this.$message.error(res.message)
      }
    },
    more () {
      this.eightpropertiesR = this.totalpropertiesR
    },
    dateSelect (date, dateString) {
      this.deviceData.queryInfoList.startDate = dateString[0]
      this.deviceData.queryInfoList.endDate = dateString[1]
    },
    proSelect (value, opt) {
      this.proSelectItem = this.proSelectItems[value]
    },
    search () {
      this.deviceData.queryInfoList.identifier = this.proSelectItem.key
      this.getDevicePropListData()
    }
  },
  beforeDestroy () {
    //  clearInterval(this.deviceData.timer)
    // clearInterval(this.deviceData.timerList)
  }
}
</script>

<style>
  /* @import "../equipmentDetailsStyle.css"; */
  .all-card-style{
    background-color: #002140;
    margin-top: 30px !important;
    width: 97.8% !important;
  }
  .topborder-box{
    width: 100.8%;
    margin-left: -0.3%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    margin-top: 0%;
  }
  .bottomborder-box{
    width: 98%;
    margin-left: 1%;
    margin-bottom: 2%;
  }
  .i{
    height: 150px;
    width: 96%;
    border: 1px solid #1F608A;
    justify-content: center;
    align-items: center;
  }
  .vurve-box{
    width: 96%;
  }
  .vurve-box{
    margin-left: 20px;
    margin-top: 20px;
  }
  .data-text{
    position: relative;
    top: 89px;
    left: 48.5%;
    font-size: 160%;
  }
  .e-img-wh{
    width: 70px !important;
    height: 70px !important;
  }
  .e-card-text-big{
    font-size: 120% !important;
    margin-top: 20px;
  }
  .e-card-text-unit{
    font-size: 100%;
    margin-left: 5px;
    color: #637188;
  }
  .e-card-text-box{
    display: flex;
    flex-direction: column;
    height: 70px;
    justify-content: space-between;
  }
  .border-x{
    width: 97%;

    margin-left: 1.5%;
    height: auto;
    border-left: 1px solid #1F608A;
    border-right: 1px solid #1F608A;

  }
  /* .hidden{
    border: 1px solid #0A2D57;
    height: 34px;
    position: absolute;
    top: 30%;
    left: 7.5%;
  } */
  .hidden {

    height: 33px;
    position: relative;
    top: 39px;
    left: 2.4%;
    width: 8px;
    background: #0A2D57;
  }
  .hidden1 {

    height: 34px;
    position: relative;
    top: 8px;
    left: 97.2%;
    width: 8px;
    background:#0A2D57;
  }
  .morebox{
    background: none !important;
    border: none !important;
  }
</style>
